import axios, { AxiosError } from "axios";
import { ApiEnvelopeError } from "./apiEnvelope";

export const handleError = (
  error: unknown,
  message: string = "Erro desconhecido.",
  success: boolean = false,
  context: string = "Ocorreu um erro."
): { message: string; success: boolean } => {
  // Erro de negócio (200 com {"error":true}): o interceptador já o transformou em
  // ApiEnvelopeError com a frase do backend. Antes caía no "else" e a tela mostrava
  // o texto genérico (ex.: "Erro inesperado ao obter perfis em acompanhamento" ao
  // cadastrar e-mail repetido, em vez de "Usuário já cadastrado com este e-mail.").
  if (error instanceof ApiEnvelopeError) {
    console.error(`${context} Erro retornado pela API:`, error.userMessage);
    return { message: error.userMessage || message, success: false };
  }
  if (axios.isAxiosError(error)) {
    const axiosError = error as AxiosError<any>;

    if (axiosError.response) {
      const status = axiosError.response.status;
      const responseData = axiosError.response.data;

      if (status >= 400 && status < 500) {
        message =
          responseData?.message ||
          "Erro na requisição do cliente, inválida ou não autorizada";
        success = false;
      } else if (status >= 500 && status < 600) {
        message =
          responseData?.message ||
          "Erro interno no servidor, inválida ou não autorizada.";
        success = false;
      } else {
        message = responseData?.message || axiosError.message || message;
        success = responseData?.success ?? success;
      }
    } else {
      message = axiosError.message || message;
    }

    console.error(`${context} Erro na requisição:`, message);
  } else {
    console.error(`${context} Erro inesperado:`, error);
  }

  return { message, success };
};
